import React from 'react'

export default function AddArticle() {
  return <span className='plus-icon' />
}
